/**
 * Organization route constants.
 *
 * Single source of truth for route names, tab identifiers, and paths used
 * by all WebMCP navigation tools. Update here when routes change — every
 * tool that imports these constants will automatically benefit.
 */

/** Vue Router name for the main Organization page */
export const ORGANIZATION_ROUTE_NAME = "NewOrganization";

/** Vue Router name for the Organization > Job Categories detail page (ER-11744). */
export const ORGANIZATION_JOB_CATEGORY_DETAIL_ROUTE_NAME = "NewOrganizationJobCategoryDetail";

/** Vue Router name for the Organization > Job Families detail page (ER-11742). */
export const ORGANIZATION_JOB_FAMILY_DETAIL_ROUTE_NAME = "OrganizationJobFamilyDetail";

/**
 * Tab identifiers as they appear in the route param `:tab` and in the
 * OrganizationPage `currentTab` ref. Values must match the router exactly.
 */
export const ORGANIZATION_TABS = Object.freeze({
  DASHBOARD: "Dashboard",
  EMPLOYEES: "Employees",
  POSITIONS: "Positions",
  ROLES: "Roles",
  RESPONSIBILITIES: "Responsibilities",
  PROCEDURES: "Procedures",
  JOB_FAMILIES: "Job Families",
});

export function organizationTabSlug(tab) {
  return String(tab || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");
}

export function findOrganizationTab(tabParam, validTabs) {
  const slug = organizationTabSlug(tabParam);
  return (validTabs || []).find((tab) => organizationTabSlug(tab) === slug) || null;
}
